<template>
  <div style="background: #eee">
    <div class="d-flex">
      <div class="flex-fill" style="width: calc(100% - 100px)">
        <div :id="`toolbar-container-${editorId}`"></div>
      </div>
      <div class="p-2" @click="changeMode()" v-if="!hideHtml">
        <check-box title="Sửa html" :value="htmlMode" />
      </div>
    </div>
    <div style="overflow: auto" v-show="!htmlMode">
      <div class="p-2" :style="{ width: $props.width, margin: 'auto' }">
        <div class="bg-white">
          <div :id="`editor-${editorId}`" />
        </div>
      </div>
    </div>
    <code>
      <textarea
        v-show="htmlMode"
        v-model="htmlValue"
        class="form-control"
        rows="20"
      />
    </code>
  </div>
</template>

<script>
import CheckBox from "./CheckBox.vue"
import { uploadFile } from "@/services/common"

export default {
  components: { CheckBox },
  props: ["width", "value", "input", "editorId", "hideHtml", "className"],
  data() {
    return {
      content: "",
      editor: null,
      htmlMode: false,
      htmlValue: "",
    }
  },

  methods: {
    changeMode() {
      if (this.htmlMode) {
        var value = this.htmlValue.replace(/\n/g, "")
        this.editor.setData(value)
        this.htmlMode = false
      } else {
        this.htmlMode = true
        this.htmlValue = this.value.replace(/></g, ">\n<")
      }
    },
    update(value) {
      if (this.editor) {
        this.editor.setData(value)
      }
    },
    addContent(text) {
      this.editor.model.change((writer) => {
        writer.insertText(
          text,
          this.editor.model.document.selection.getFirstPosition(),
        )
      })
      this.editor.editing.view.focus()
    },
    setEditor() {
      window.DecoupledEditor.create(
        document.querySelector("#editor-" + this.editorId),
        {
          initialData: this.value || "<p></p>",
          extraPlugins: [UploadImage, ClassNamePlugin],
          allowedContent: true,
          className: this.className,
        },
      ).then((editor) => {
        //console.log("Editor was initialized", editor);
        this.editor = editor
        const toolbarContainer = document.querySelector(
          "#toolbar-container-" + this.editorId,
        )
        editor.setData(this.value)
        toolbarContainer.appendChild(editor.ui.view.toolbar.element)
        editor.model.document.on("change", () => {
          //console.log("change", editor.getData());
          var value = editor.getData()
          this.$emit("input", value)
          this.$emit("change", value)
        })
      })
    },
  },
  mounted() {
    //console.log("mounted", this.value);
    this.setEditor()
  },
}
class MyUploadAdapter {
  constructor(loader) {
    this.loader = loader
  }
  upload() {
    return this.loader.file.then(
      (file) =>
        new Promise((resolve, reject) => {
          // Sử dụng API upload thay vì base64
          const uploadToApi = async (file) => {
            try {
              const i = await uploadFile(file)

              return i.fileDownloadUri
            } catch (error) {
              throw error
            }
          }

          return uploadToApi(file)
            .then((fileUrl) => {
              this.loader.uploaded = true
              resolve({
                default: fileUrl,
              })
            })
            .catch((error) => {
              reject(error)
            })
        }),
    )
  }
}

function UploadImage(editor) {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader)
  }
}

function ClassNamePlugin(editor) {
  // Extend schema for common block elements to allow htmlClass attribute
  const blockElements = [
    "paragraph",
    "heading1",
    "heading2",
    "heading3",
    "heading4",
    "heading5",
    "heading6",
    "blockQuote",
    "listItem",
    "table",
    "tableCell",
    "imageBlock",
  ]
  for (const el of blockElements) {
    if (editor.model.schema.isRegistered(el)) {
      editor.model.schema.extend(el, { allowAttributes: "htmlClass" })
    }
  }

  // Downcast: model htmlClass → view class attribute
  editor.conversion.for("downcast").add((dispatcher) => {
    dispatcher.on("attribute:htmlClass", (evt, data, conversionApi) => {
      const { item, attributeNewValue } = data
      if (!item.is("element")) return
      const viewElement = conversionApi.mapper.toViewElement(item)
      if (!viewElement) return

      conversionApi.writer.setAttribute(
        "class",
        attributeNewValue || "",
        viewElement,
      )
      if (!attributeNewValue) {
        conversionApi.writer.removeAttribute("class", viewElement)
      }
    })
  })

  // Upcast: view class → model htmlClass attribute
  editor.conversion.for("upcast").add((dispatcher) => {
    dispatcher.on(
      "element",
      (evt, data, conversionApi) => {
        const { viewItem, modelRange } = data
        if (!modelRange) return
        const classes = [...viewItem.getClassNames()].join(" ").trim()
        if (!classes) return
        for (const item of modelRange.getItems()) {
          if (
            item.is("element") &&
            editor.model.schema.checkAttribute(item, "htmlClass")
          ) {
            conversionApi.writer.setAttribute("htmlClass", classes, item)
          }
        }
      },
      { priority: "low" },
    )
  })

  // Inject className input into toolbar after editor is ready
  editor.on("ready", () => {
    const toolbar = editor.ui.view.toolbar.element

    const separator = document.createElement("span")
    separator.className = "ck ck-toolbar__separator"

    const wrapper = document.createElement("div")
    wrapper.style.cssText =
      "display:flex;align-items:center;gap:4px;padding:0 6px;"

    const label = document.createElement("span")
    label.textContent = "Class:"
    label.style.cssText = "font-size:12px;color:#555;white-space:nowrap;"

    const input = document.createElement("input")
    input.type = "text"
    input.placeholder = "className"
    input.style.cssText =
      "width:120px;height:26px;border:1px solid #c4c8cc;border-radius:2px;padding:0 6px;font-size:13px;outline:none;"

    // Reflect class of currently focused block in the input
    editor.model.document.selection.on("change", () => {
      const pos = editor.model.document.selection.getFirstPosition()
      if (!pos) return
      const block = pos.parent
      input.value = block.getAttribute("htmlClass") || ""
    })

    // Apply typed class to all selected blocks
    input.addEventListener("change", () => {
      const className = input.value.trim()
      editor.model.change((writer) => {
        for (const block of editor.model.document.selection.getSelectedBlocks()) {
          if (editor.model.schema.checkAttribute(block, "htmlClass")) {
            if (className) {
              writer.setAttribute("htmlClass", className, block)
            } else {
              writer.removeAttribute("htmlClass", block)
            }
          }
        }
      })
    })

    wrapper.appendChild(label)
    wrapper.appendChild(input)
    toolbar.appendChild(separator)
    toolbar.appendChild(wrapper)
  })
}
</script>

<style lang="scss">
.ck-editor__editable {
  min-height: 300px;
}
</style>
